import { render, staticRenderFns } from "./LichSuDichVuGiaiTriList.vue?vue&type=template&id=5db4322e"
import script from "./LichSuDichVuGiaiTriList.vue?vue&type=script&lang=js"
export * from "./LichSuDichVuGiaiTriList.vue?vue&type=script&lang=js"
import style0 from "./LichSuDichVuGiaiTriList.vue?vue&type=style&index=0&id=5db4322e&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports